<template>
  <div>
    <v-navigation-drawer
      width="228"
      clipped
      app
      :hide-overlay="true"
      v-model="drawer"
      style="z-index: 101"
    >
      <v-list class="text_d" flat dense rounded>
        <v-list-item-group color="primary">
          <!-- <div style="height: 10px"></div> -->
          <v-list-item link :to="'/invoice'">
            <v-list-item-content>
              <v-list-item-title>Invoice</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--   <div style="height: 10px"></div>
       <v-list-item link :to="'/installment'">
            <v-list-item-content>
              <v-list-item-title>Billing</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!-- <v-list-item
            link :to="'/aging'"
            v-if="
              role_name != 'down_service'
            ">
            <v-list-item-content>
              <v-list-item-title>Aging</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!-- <v-list-item
            link
            :to="'/loginvoice'"
            v-if="
              role_name != 'down_service' &&
                role_name != 'wait_down_service' &&
                role_name != 'viewer'
            "
          >
            <v-list-item-content>
              <v-list-item-title>Log Invoice</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-group
            v-if="
              role_name != 'down_service' &&
              biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'
            "
          >
            <!-- <template v-slot:activator :hide-overlay="true"> -->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>หนังสือทวงหนี้</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              link
              :to="'/invoice-book-1'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title>
                  - หนังสือทวงหนี้ครั้งที่ 1</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="'/invoice-book-2'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title>
                  - หนังสือทวงหนี้ครั้งที่ 2</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="'/invoice-book-other'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title> - หนังสือทวงหนี้อื่นๆ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="'/interest'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title> - ดอกเบี้ย</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/down-service'">
              <v-list-item-content>
                <v-list-item-title> - ปิดระบบ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="'/prosecute'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title> - ส่งดำเนินคดี</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              :to="'/bad-debt'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title> - ตัดหนี้สูญ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              link
              :to="'/invoice-book-close'"
              v-if="
                role_name != 'down_service'
              "
            >
              <v-list-item-content>
                <v-list-item-title> - รอปิดระบบ</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item
              link
              :to="'/log-invoice-book'"
              v-if="role_name != 'down_service'"
            >
              <v-list-item-content>
                <v-list-item-title> - Report หนังสือทวงหนี้</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <!-- <v-list-item
            link
            :to="'/detail-plan'"
            v-if="
              role_name != 'down_service' && role_name != 'viewer'
            "
          >
            <v-list-item-content>
              <v-list-item-title>Detail Plan</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!-- <v-list-item
            link
            :to="'/sum-plan'"
            v-if="
              role_name != 'down_service' && role_name != 'viewer'
            "
          >
            <v-list-item-content>
              <v-list-item-title>Sum Plan</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <!--
          <v-list-item link :to="'/manage-user'" v-if="role_name == 'super_admin'">
          <v-list-item-content>
              <v-list-item-title>Manage User</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

            <v-list-item link :to="'/customer-manage'"
          v-if="role_name != 'down_service' &&
          role_name != 'wait_down_service' &&
          role_name != 'viewer'">
            <v-list-item-content>
              <v-list-item-title>Customer Manage</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <v-list-group v-if="role_name != 'down_service'">
            <!-- <template v-slot:activator :hide-overlay="true"> -->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Manage</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link :to="'/manage-user'">
              <v-list-item-content>
                <v-list-item-title> - Manage User</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/customer-manage'">
              <v-list-item-content>
                <v-list-item-title> - Customer Manage</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/calendar'">
              <v-list-item-content>
                <v-list-item-title> - Calendar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/log-customer-contact'">
              <v-list-item-content>
                <v-list-item-title> - Log Customer Contact</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group
            v-if="
              role_name != 'down_service' &&
              biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'
            "
          >
            <!-- <template v-slot:activator :hide-overlay="true"> -->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Report Billing</v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- <v-list-item link :to="'/dashboard-report-billing'"
              v-if="role_name != 'viewer'">
              <v-list-item-content >
                <v-list-item-title> - Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- <v-list-item link :to="'/target-billing-report'">
              <v-list-item-content>
                <v-list-item-title> - Target Billing Report </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item link :to="'/finance-customer'">
              <v-list-item-content>
                <v-list-item-title>
                  - สรุปลูกค้าตามเจ้าหน้าที่การเงิน</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item link :to="'/log-report-due'">
              <v-list-item-content>
                <v-list-item-title> - ประวัติการชำระ</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list-group>

          <!-- เพิ่มเมนู Log มาใหม่ -->
          <v-list-group
            v-if="role_name != 'down_service' && role_name != 'viewer'"
          >
            <template v-slot:activator>
              <v-list-item-title>Log</v-list-item-title>
            </template>
            <v-list-item link :to="'/loginvoice'">
              <v-list-item-content>
                <v-list-item-title> - Log Invoice</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item link :to="'/logrequest'">
              <v-list-item-content>
                <v-list-item-title> - Log Request</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <!-- <v-list-item link :to="'/log-invoice-book'">
              <v-list-item-content>
                <v-list-item-title> - Log หนังสือทวงหนี้</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-group
              v-if="biz_name == 'บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)'"
              sub-group
              prepend-icon="mdi-user"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    - Log Request
                    <v-icon
                      style="float: right"
                      class="bgicon"
                      @click="seticon"
                      >{{ sumicon }}</v-icon
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item link :to="'/request-billing'">
                <v-list-item-content>
                  <v-list-item-title>- ใบแจ้งหนี้</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/request-receipt'">
                <v-list-item-content>
                  <v-list-item-title>- ใบเสร็จ</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/request-payment'">
                <v-list-item-content>
                  <v-list-item-title>- ติดตามการชำระ</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/request-wht'">
                <v-list-item-content>
                  <v-list-item-title>- เอกสาร WHT</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>

          <v-list-group
            v-if="role_name != 'viewer' && role_name != 'down_service'"
          >
            <!-- <template v-slot:activator :hide-overlay="true"> -->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Bank Statement</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link :to="'/pending'">
              <v-list-item-content>
                <v-list-item-title> - Pending</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/matched'">
              <v-list-item-content>
                <v-list-item-title> - Matched</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/success'">
              <v-list-item-content>
                <v-list-item-title> - Success</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/report-bank-statement'">
              <v-list-item-content>
                <v-list-item-title> - Report Bank Statement</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/log-reverse'">
              <v-list-item-content>
                <v-list-item-title> - Log Reverse</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group sub-group prepend-icon="mdi-user">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    - Dashboard RV
                    <v-icon
                      style="float: right"
                      class="bgicon"
                      @click="seticon"
                      >{{ sumicon }}</v-icon
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item link :to="'/report-key-rv'">
                <v-list-item-content>
                  <v-list-item-title>- Report Key RV</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/report-day2day'">
                <v-list-item-content>
                  <v-list-item-title>- Report Day2Day</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/report-overview-rv'">
                <v-list-item-content>
                  <v-list-item-title>- Report ภาพรวม RV</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item link :to="'/report-all'">
                <v-list-item-content>
                  <v-list-item-title
                    >- Chart ภาพรวมเปรียบเทียบ</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-group>
          <!-- สิ้นสุด -->

          <!-- <v-list-group>
            <template v-slot:activator :hide-overlay="true">
              <v-list-item-content>
                <v-list-item-title>ใบแจ้งหนี้/ใบเสร็จ</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link :to="'/preview'">
              <v-list-item-content>
                <v-list-item-title> - Preview</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link :to="'/request-pdf'">
              <v-list-item-content>
                <v-list-item-title> - Request</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group> -->

          <!-- <v-list-item link :to="'/log-report-due'"
          v-if="role_name != 'down_service' &&
          role_name != 'wait_down_service' &&
          role_name != 'viewer'">
            <v-list-item-content>
              <v-list-item-title>ประวัติการชำระ</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          <div style="height: 10px"></div>
          <v-list-item link @click="logout()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <v-speed-dial
          v-model="fab"
          :top="top"
          :bottom="bottom"
          :right="right"
          :left="left"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="#63B6C2" dark fab>
              <v-icon v-if="fab"> mdi-help </v-icon>
              <v-icon v-else> mdi-help </v-icon>
            </v-btn>
          </template>
          <div class="d-flex align-center mb-2">
            <v-tooltip right attach>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  color="#429488"
                  dark
                  @click="downloadFile"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-book-open</v-icon>
                </v-btn>
              </template>
              <span>User Manual</span>
            </v-tooltip>
          </div>
          <div
            v-if="role_status == 'master_admin'"
            class="d-flex align-center mb-2"
          >
            <v-tooltip right attach>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  color="#4193CC"
                  dark
                  @click="openDialogUpload"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-file-upload-outline</v-icon>
                </v-btn>
              </template>
              <span>Upload File</span>
            </v-tooltip>
          </div>
          <div v-if="isRoleAllowedToPatch" class="d-flex align-center mb-2">
            <v-tooltip right attach>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  color="#2E7D32"
                  dark
                  @click="openExcelPatchUpload"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-btn>
              </template>
              <span>Excel Patch / Sync</span>
            </v-tooltip>
          </div>
        </v-speed-dial>
      </template>
    </v-navigation-drawer>
    <openDialogUpload />
    <ExcelPatchUploadDialog />
  </div>
</template>
<script>
import eventBus from "../event-bus";
import openDialogUpload from "../components/DialogUploadFile.vue";
import ExcelPatchUploadDialog from "../components/ExcelPatchUploadDialog.vue";
import Swal from "sweetalert2";
export default {
  components: {
    openDialogUpload,
    ExcelPatchUploadDialog,
  },
  data() {
    return {
      role_name: "",
      wait_role: "",
      drawer: window.innerWidth > 1264 ? true : false,
      role: [],
      biz_name: "",
      sumicon: "mdi-chevron-down",
      iconlog: 0,

      direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      biz_id: "",
      download_link: "",
      file_details: "",
      file_id: "",
      file_name: "",
      file_type: "",
      folder_id: "",
    };
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  created() {
    this.role_status = localStorage.getItem("role");
    this.role_name = localStorage.getItem("role");
    this.wait_role = localStorage.getItem("wait_role");
    this.biz_name = localStorage.getItem("biz_name");
    this.biz_id = localStorage.getItem("biz_id");
    // this.role = JSON.parse(localStorage.getItem('role'))
    // var decode_1 = atob(localStorage.getItem("role"))
    //  var decode_2 = decode_1.split('').reverse().join('')
    //  var decode_3 = atob(decode_2)
    //  console.log(decode_3)
    //    vdecode_1ar decode =atob(encode)
    //  this.role_name = decode_3
  },
  mounted() {
    eventBus.$on("click", () => {
      this.drawer = !this.drawer;
    });
  },
  methods: {
    seticon() {
      this.iconlog += 1;
      if (this.iconlog % 2 === 0) {
        this.sumicon = "mdi-chevron-down";
      } else {
        this.sumicon = "mdi-chevron-up";
      }
    },
    logout() {
      localStorage.clear();
      this.$router.push("/login");
    },
    openDialogUpload() {
      console.log("asdasdasd");
      eventBus.$emit("openDialogUpload");
    },
    openExcelPatchUpload() {
      eventBus.$emit("openExcelPatchUpload");
    },
    downloadFile() {
      const headers = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
      };

      this.axios
        .get(
          process.env.VUE_APP_API +
            "/file/download/filetooling?biz_id=" +
            this.biz_id,
          headers
        )
        .then((response) => {
          if (response.status === 200 && response.data.data.file_details) {
            const base64Data = response.data.data.file_details;

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, "_blank");
          } else {
            throw new Error("File data not available");
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการเปิดไฟล์",
            showConfirmButton: false,
            timer: 2000,
          });
          console.error("Error previewing file:", error);
        });
    },
  },
  computed: {
    isRoleAllowedToPatch() {
      const allowedRoles = ["master_admin"];
      return allowedRoles.includes(this.role_status);
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.text_d {
  font-family: "Bai_Jamjuree" !important;
}
.application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
.v-item-group .theme--light .v-list-item-group .primary--text {
  margin-top: 60px !important;
}
.v-navigation-drawer .v-list:not(.v-select-list) {
  margin-top: 35px !important;
  background: inherit;
}
.v-list--dense .v-list-item .v-list-item__title {
  line-height: 1.5rem !important;
}

.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  top: 40px !important;
}
.v-application--is-ltr
  .v-list--dense
  .v-list-group--sub-group
  .v-list-group__header {
  padding-left: 0px;
  margin-left: -6.5%;
}
.bgicon.v-icon::after {
  background-color: #ffff;
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: scale(1.3);
  width: 100%;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.v-speed-dial--right {
  right: -16px !important;
}
.v-speed-dial--bottom {
  bottom: 22px !important;
}
.v-speed-dial__list {
  align-items: flex-start !important;
  display: flex !important;
  justify-content: center !important;
  padding: 8px 0 !important;
  position: absolute !important;
}
.v-speed-dial--direction-top .v-speed-dial__list,
.v-speed-dial--direction-bottom .v-speed-dial__list {
  left: 0px !important;
  width: 100% !important;
}
.v-speed-dial__list .v-btn {
  margin: 0px !important;
}
.text-style {
  font-family: "Bai_Jamjuree" !important;
}
.v-tooltip {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
</style>
